import { useMemo, useCallback } from "react";
import {
  columnasValidacionesHojaQX,
  columnasAnexos,
  renderActionColumn,
  prepararDataAnexos,
} from "../utils/ValidacionesHojaQXScreenTableUtils";

const useValidacionesHojaQXScreenTable = ({
  visibleActionsMenu,
  setVisibleActionsMenu,
  empresa,
  actionsOptions,
  handleMenuClick,
  generarRecordKey,
  abrirModalDocumento,
  anexosAMostrar,
  tipoReclamante,
}) => {
  const renderActionColumnCallback = useCallback(
    (record) => {
      return renderActionColumn({
        record,
        visibleActionsMenu,
        setVisibleActionsMenu,
        empresa,
        actionsOptions,
        handleMenuClick,
        generarRecordKey,
      });
    },
    [
      visibleActionsMenu,
      setVisibleActionsMenu,
      empresa,
      actionsOptions,
      handleMenuClick,
      generarRecordKey,
    ]
  );

  const columns = useMemo(
    () => columnasValidacionesHojaQX({ 
      renderActionColumn: renderActionColumnCallback,
      tipoReclamante,
    }),
    [renderActionColumnCallback, tipoReclamante]
  );

  const columnsAnexosMemo = useMemo(
    () => columnasAnexos({ abrirModalDocumento }),
    [abrirModalDocumento]
  );

  const dataAnexos = useMemo(
    () => prepararDataAnexos(anexosAMostrar),
    [anexosAMostrar]
  );

  return {
    columns,
    columnsAnexosMemo,
    dataAnexos,
  };
};

export default useValidacionesHojaQXScreenTable;

